import { render, staticRenderFns } from "./analyticsOfficialQrcode.vue?vue&type=template&id=b4cd104a"
import script from "./analyticsOfficialQrcode.vue?vue&type=script&lang=js"
export * from "./analyticsOfficialQrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports